import { Auth } from "aws-amplify";
import ICurrentUser from "../entities/helper/ICurrentUser";
import { UsuariosExternosServices } from "../services/UsuariosExternosServices";
import { INTERNAL_EMAIL_DOMAINS } from "./variableHelper";

export const ALWAYS_INTERNAL_EMAIL_DOMAINS = Object.freeze(["transelec.cl"]);

export const DEFAULT_INTERNAL_EMAIL_DOMAINS = Object.freeze(["conelsur.com"]);

export const parseInternalEmailDomains = (raw?: string): string[] => {
  const configurados = (raw ?? "")
    .split(",")
    .map((dominio) => dominio.trim().toLowerCase().replace(/^@+/, ""))
    .filter((dominio) => dominio.length > 0);
  const adicionales = configurados.length > 0 ? configurados : DEFAULT_INTERNAL_EMAIL_DOMAINS;
  return Array.from(new Set([...ALWAYS_INTERNAL_EMAIL_DOMAINS, ...adicionales]));
};

export const getInternalEmailDomains = (): string[] => parseInternalEmailDomains(INTERNAL_EMAIL_DOMAINS);

export const isInternalEmailDomain = (email: string, dominios: string[] = getInternalEmailDomains()): boolean => {
  const normalizado = email.trim().toLowerCase();
  return dominios.some((dominio) => normalizado.endsWith(`@${dominio}`));
};

export const cognitoUserInfo = async (): Promise<ICurrentUser> => {
  let cognitoUserInfo: ICurrentUser;
  try {
    let userInfo = await Auth.currentAuthenticatedUser();
    const federadoAzureAD = userInfo.username.includes("azuread");
    const dominioInterno = isInternalEmailDomain(userInfo.attributes.email);
    let isExternal = !(federadoAzureAD || dominioInterno);

    cognitoUserInfo = {
      email: userInfo.attributes.email,
      name: userInfo.attributes.given_name,
      surname: userInfo.attributes.family_name,
      fullname: [userInfo.attributes?.given_name, userInfo.attributes?.family_name].join(" ").trim(),
      external: isExternal,
      roles: {
        IS_ADMIN: false,
        IS_ADMIN_AUDITORIA: false,
        IS_ADMIN_PROVEEDORES: false,
      },
    };
    let token = await cognitoUserToken();
    let roles = await UsuariosExternosServices.checkRolesAsignados(token, { EMAIL: cognitoUserInfo.email });
    cognitoUserInfo.roles = roles;
    if (cognitoUserInfo.roles.IS_ADMIN) {
      cognitoUserInfo.external = false;
    }
  } catch (e) {
    cognitoUserInfo = {
      email: "",
      name: "",
      surname: "",
      fullname: "",
      external: false,
      roles: {
        IS_ADMIN: false,
        IS_ADMIN_AUDITORIA: false,
        IS_ADMIN_PROVEEDORES: false,
      },
    };
  }
  return cognitoUserInfo;
};

export const cognitoUserToken = async (): Promise<string> => {
  try {
    let userInfo = await Auth.currentAuthenticatedUser();
    return userInfo.signInUserSession.idToken.jwtToken;
  } catch (e) {
    return "";
  }
};
